import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material';

const StyledBox = styled(Box)`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999999999;
`;

const StyledLinearProgress = styled(LinearProgress)`
  background-color: rgba(95, 195, 200, 0.57);

  .MuiLinearProgress-bar {
    background-color: #199da3;
  }
`;

export function UiLinearLoading() {
  return (
    <StyledBox>
      <StyledLinearProgress />
    </StyledBox>
  );
}
